// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSameQuarter as fn } from "../isSameQuarter.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSameQuarterWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default isSameQuarterWithOptions;
